﻿(() => {
  if (customElements.get('recommended-for-you')) return;
  class RecommendedForYou extends HTMLElement {
    static tokens(title) {
      return [...new Set((title || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().match(/[\p{L}\p{N}]+/gu) || [])];
    }
    static select(candidates, currentId, currentTitle) {
      const seen = new Set();
      const items = candidates.filter((item) => {
        if (item.id === currentId || seen.has(item.id)) return false;
        seen.add(item.id);
        return true;
      });
      const isYear = (word) => /^(?:17|18|19|20|21)\d{2}$/.test(word);
      const seriesTokens = (title) => this.tokens(title).filter((word) => !isYear(word));
      const year = (title) => Math.max(0, ...this.tokens(title).filter(isYear).map(Number));
      const target = seriesTokens(currentTitle);
      // Match the coin series without its year, then order matching coins newest first.
      const common = new Set(['silver', 'coin', 'coins', 'oz', 'ounce', 'ounces', 'troy', 'bu', 'the', 'and', 'of', '1']);
      const weight = (word) => common.has(word) || /^\d+$/.test(word) ? 0.25 : 1;
      const score = (title) => {
        const words = seriesTokens(title);
        const union = new Set([...target, ...words]);
        let shared = 0;
        let total = 0;
        for (const word of union) {
          total += weight(word);
          if (target.includes(word) && words.includes(word)) shared += weight(word);
        }
        return total ? shared / total : 0;
      };
      return items.map((item, index) => ({ item, index, score: score(item.title), year: year(item.title) }))
        .sort((a, b) => Number(Boolean(b.item.featured)) - Number(Boolean(a.item.featured)) || b.score - a.score || b.year - a.year || a.index - b.index)
        .slice(0, 4).map(({ item }) => item);
    }
    readCandidates(root) {
      return [...root.querySelectorAll('template[data-recommendation]')].map((template) => ({
        id: template.dataset.productId,
        title: template.dataset.title,
        featured: template.dataset.featured === 'true',
        template
      }));
    }
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.load(this.controller.signal);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
    async load(signal) {
      const candidates = this.readCandidates(this);
      const visited = new Set();
      let next = this.querySelector('[data-next-page]')?.dataset.nextPage;
      this.render(candidates);
      try {
        while (next && !signal.aborted) {
          const url = new URL(next, window.location.href);
          url.searchParams.set('section_id', this.dataset.sectionId);
          if (url.origin !== window.location.origin || visited.has(url.href)) break;
          visited.add(url.href);
          const response = await fetch(url, { signal });
          if (!response.ok) throw new Error('Unable to load recommendation candidates');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const section = doc.querySelector('recommended-for-you');
          if (!section) break;
          candidates.push(...this.readCandidates(section));
          next = section.querySelector('[data-next-page]')?.dataset.nextPage;
        }
      } catch (error) {
        if (signal.aborted) return;
        // Keep the best available recommendations if a catalog page fails.
        console.warn('Product recommendations:', error);
      }
      if (!signal.aborted) this.render(candidates);
    }
    render(candidates) {
      const selected = RecommendedForYou.select(candidates, this.dataset.currentProduct, this.dataset.currentTitle);
      const key = selected.map((item) => item.id).join(',');
      if (this.selectionKey !== key) {
        this.querySelector('.collection-carousel__track').replaceChildren(...selected.map((item) => item.template.content.cloneNode(true)));
        this.selectionKey = key;
      }
      const carousel = this.querySelector('collection-product-carousel');
      if (carousel?.track) carousel.update();
      const notice = this.querySelector('.recommended-coins__notice');
      if (notice) notice.hidden = selected.length === 4;
      this.hidden = !selected.length && !notice;
    }
  }
  customElements.define('recommended-for-you', RecommendedForYou);
})();
